import Hero from "./components/hero/Hero";
import Nav from "./components/nav/Nav";
import ThemeCarousel from "./components/themes/Themes";
import Intro from "./components/intro/Intro";
import Bridge from "./components/intro/Bridge";
import { TheWordRevealed } from "./components/theme-section/RevealTheWord";
import JoinCta from "./components/footer/Cta";

function App() {
  return (
    <>
      <Nav />
      <Hero />
      <Intro />
      <Bridge />
      <ThemeCarousel />
      <TheWordRevealed />
      <JoinCta />
    </>
  );
}

export default App;
